<template>
  <div class="title">
    <p>{{ this.title }}</p>
  </div>
</template>

<script>
export default {
  name: 'FtaTitle',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="less">
.title {
  margin: 0 34px;
  background-image: linear-gradient(0deg, #A1D6FF 0%, #3897FF 100%);
  height: 48px;
  border-radius: 24px;
  padding-top: 0px;

  > p {
    line-height: 48px;
    margin-bottom: 0;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: -0.32px;
    text-align: center;
    font-weight: 700;
  }
}
</style>
